import { render, staticRenderFns } from "./VeJwCjsettingList.vue?vue&type=template&id=2190817d&scoped=true"
import script from "./VeJwCjsettingList.vue?vue&type=script&lang=js"
export * from "./VeJwCjsettingList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2190817d",
  null
  
)

export default component.exports